import * as PIXI from "pixi.js";
import "pixi-spine";
import "pixi-extra-filters";
import "pixi-particles";

import jquery from "jquery";
global.$ = jquery;

import "../libs/p3.min";

import Main from './Main';

import {TweenMax, Power2, TimelineLite} from "gsap/TweenMax";

//import "p2";

const main = new Main(1024, 768);
main.init();